import {Directive, Self} from '@angular/core';
import {NgControl} from './ng_control';
import {isPresent} from '../../facade/lang';
export class NgControlStatus {
  private _cd: NgControl;

  constructor( cd: NgControl) { this._cd = cd; }

  get ngClassUntouched(): boolean {
    return isPresent(this._cd.control) ? this._cd.control.untouched : false;
  }
  get ngClassTouched(): boolean {
    return isPresent(this._cd.control) ? this._cd.control.touched : false;
  }
  get ngClassPristine(): boolean {
    return isPresent(this._cd.control) ? this._cd.control.pristine : false;
  }
  get ngClassDirty(): boolean {
    return isPresent(this._cd.control) ? this._cd.control.dirty : false;
  }
  get ngClassValid(): boolean {
    return isPresent(this._cd.control) ? this._cd.control.valid : false;
  }
  get ngClassInvalid(): boolean {
    return isPresent(this._cd.control) ? !this._cd.control.valid : false;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[ngControl],[ngModel],[ngFormControl]',
  host: {
    '[class.ng-untouched]': 'ngClassUntouched',
    '[class.ng-touched]': 'ngClassTouched',
    '[class.ng-pristine]': 'ngClassPristine',
    '[class.ng-dirty]': 'ngClassDirty',
    '[class.ng-valid]': 'ngClassValid',
    '[class.ng-invalid]': 'ngClassInvalid'
  }
}, ] },
];
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: NgControl, decorators: [{ type: Self }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
